import React from 'react';
import { NavLink } from 'react-router-dom';

import './sidenav.css';

const navItems = [
  { icon: 'fa-solid fa-house', label: 'Home', path: '/' },
  { icon: 'fa-solid fa-wand-magic-sparkles', label: 'AI Gen', path: '/ai' },
  {
    label: 'Character',
    path: '/character',
    customIcon: (
      <svg
        className="side-nav__character-icon"
        viewBox="0 0 32 32"
        aria-hidden="true"
      >
        <circle cx="13" cy="11" r="5" fill="currentColor" />
        <path
          d="M6.5 24.5c0-3.9 3.2-7 7.1-7h0.4c3.9 0 7.1 3.1 7.1 7v1H6.5v-1z"
          fill="currentColor"
        />
        <path
          d="M24.5 4.5l1.1 3.4L29 9l-3.4 1.1-1.1 3.4-1.1-3.4L20 9l3.4-1.1 1.1-3.4z"
          fill="currentColor"
        />
        <path
          d="M27.5 13.5l0.6 1.8 1.8 0.6-1.8 0.6-0.6 1.8-0.6-1.8-1.8-0.6 1.8-0.6 0.6-1.8z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    label: 'Template',
    path: '/templates',
    customIcon: (
      <svg
        className="side-nav__template-icon"
        viewBox="0 0 32 32"
        aria-hidden="true"
      >
        <rect
          x="5"
          y="11"
          width="15.5"
          height="12.5"
          rx="3"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
        />
        <path
          d="M8 20.2l3.5-3.5 2.5 2.5 1.7-1.7 2.8 2.7"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <circle cx="10.2" cy="14.4" r="1.2" fill="currentColor" />
        <path
          d="M25.5 4.5l1.1 3.2 3.2 1.1-3.2 1.1-1.1 3.2-1.1-3.2-3.2-1.1 3.2-1.1 1.1-3.2z"
          fill="currentColor"
        />
        <path
          d="M27 15.5l0.7 2 2 0.7-2 0.7-0.7 2-0.7-2-2-0.7 2-0.7 0.7-2z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  { icon: 'fa-regular fa-images', label: 'Gallery', path: '/gallery' },
  { icon: 'fa-regular fa-user', label: 'Account', path: '/account' },
  { icon: 'fa-regular fa-circle-question', label: 'Help', path: '/help' },
];

const SideNav = () => (
  <aside className="side-nav">
    <div className="side-nav__items">
      {navItems.map((item) => (
        <NavLink
          key={item.label}
          exact={item.path === '/'}
          to={item.path}
          className="side-nav__item"
          activeClassName="is-active"
        >
          {item.customIcon || <i className={item.icon} />}
          <span>{item.label}</span>
        </NavLink>
      ))}
    </div>
  </aside>
);

export default SideNav;
